import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import store from './rtk/store/store';
import { Provider } from 'react-redux';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from 'react-oidc-context';
import { NestedSubGroupProvider } from './contexts/NestedSubGroupContext';
import { GroupDataProvider } from './contexts/GroupDataContext';
import { TabProvider } from './contexts/TabContext';
import CloudFrontSessionInitializer from './utils/authhelpers/cloudfrontSessionHelper';

const cognitoAuthConfig = {
  authority: process.env.REACT_APP_COGNITO_AUTHORITY,
  client_id: process.env.REACT_APP_COGNITO_CLIENT_ID,
  redirect_uri: process.env.REACT_APP_REDIRECT_URI,
  post_logout_redirect_uri: 'http://localhost:3000/',
  response_type: 'code',
  scope: 'email openid profile',
  // Cognito tokens last an hour. Renew them in the background, using the
  // refresh token from the code flow (no hidden iframe involved), so long
  // sessions keep working: the API signs every request with the id token, and
  // the CloudFront session for the FHIR IG iframe is re-minted with it too.
  automaticSilentRenew: true,
  // Start renewing five minutes out rather than the default sixty seconds, so
  // a slow or briefly-failing renewal has room to retry before anything
  // expires.
  accessTokenExpiringNotificationTimeInSeconds: 300,
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider {...cognitoAuthConfig}>
      <CloudFrontSessionInitializer />
      <Provider store={store}>
        <TabProvider>
          <NestedSubGroupProvider>
            <GroupDataProvider>
              <App />
            </GroupDataProvider>
          </NestedSubGroupProvider>
        </TabProvider>
      </Provider>
    </AuthProvider>
  </React.StrictMode>
);

reportWebVitals();
